/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'reports': {
    width: 15,
    height: 20,
    viewBox: '0 0 15 20',
    data: '<g _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M3.179 15.811h5M3.179 13.141h8" _stroke="#008AFF"/><path pid="1" _stroke="#234357" d="M.708 1.488h9.719l1.794 1.724 1.795 1.723v14.519H.708z"/><path pid="2" _stroke="#234357" d="M10.427 1.488v3.447h3.589M3.18 7.456h8v3.015h-8z"/></g>'
  }
})
